
import { apiCall } from './apiCall';
  
  
  
export default function merchentApi() {
  return {
    getMerchentList: (data,token) => apiCall('/getMerchentList',data, token),
    getMerchantsById: (data,token) => apiCall('/getMerchentById',data, token),
    create: (data,token) => apiCall('/addMerchent',data, token),
    update: (data,token) => apiCall('/updateMerchent',data, token),
    getTopUpHistory: (data,token) => apiCall('/getTopUpHistory',data, token),
    getMerchantListRequest: (data,token) => apiCall('/getMerchentRequestList',data, token),
    getMerchantsRequestById : (data,token) => apiCall('/getMerchentRequestById',data, token),
    acceptMerchantsRequest : (data,token) => apiCall('/acceptMerchentRequest',data, token),
    updateMerchantsRequest : (data,token) => apiCall('/updateMerchentRequest',data, token),
    getMerchantAgreementView : (data,token) => apiCall('/getMerchentAgreementView',data, token),
    getMerchantAgreement : (data,token) => apiCall('/getMerchentAgreement',data, token),
    updateMerchantAgreement : (data,token) => apiCall('/updateMerchentAgreement',data, token),

    generateMerchentKey : (data,token) => apiCall('/generateMerchentKey',data, token),
    getDocsByMerchentRequestId : (data,token) => apiCall('/getDocsByMerchentRequestId',data, token),
    addMerchantRequestDocuments : (data,token) => apiCall('/addMerchantRequestDocuments',data, token),
    deleteMerchentRequestDocuments : (data,token) => apiCall('/deleteMerchentRequestDocuments',data, token),

    getDocsByMerchantId : (data,token) => apiCall('/getDocsByMerchantId',data, token),
    addMerchantDocuments : (data,token) => apiCall('/addMerchantDocuments',data, token),
    deleteDocuments : (data,token) => apiCall('/deleteDocuments',data, token),
    deleteMerchent : (data,token) => apiCall('/deleteMerchent',data, token),
    
    
    
    
  };
}
